<script setup>
    import Header from './Header.vue'
</script>

<template>
    <Header />

<div class="container mx-auto max-w-prose">
<h1 class="font-bold text-2xl mt-4 mb-2">Privacy Policy</h1>

<span class="font-thin">Last modified 27 Februari 2025</span>

<h2>TLDR;</h2>
<ul>
    <li>We collect as little information as possible.</li>
    <li>We never sell or share personal data.</li>
    <li>Communication is stored and can be reviewed by moderators.</li>
</ul>

<h2>Information Collected on OpenGammon</h2>
<ul>
    <li><b>User submitted information:</b> We collect the email address and any information you add to your public profile.</li>
    <li><b>Technical Information:</b> We collect IP addresses, and basic client usage statistics.</li>
    <li><b>Communication:</b> Communication on OpenGammon is stored including, but not limited to, chat, blog posts, messages.</li>
</ul>


<h2>Why we collect the information and how it is used.</h2>
<ul>
    <li><b>User submitted information:</b> The email address collected at 
        registration is used to prevent multi-accounting and is used to gain 
        access to your account. Moderators are able to set a new email address to
        help troubleshooting.

        Any content you add to your account is optional, and is publicly visible.
    </li>
    <li><b>Technical Information:</b>Your IP address(es) are private and are not 
        visible to anybody except for OpenGammon moderators. This information is used
        to prevent abuse.

        We use basic client usage information, including but not limited to <i>Blurs</i>
        as a means to prevent cheating.
    </li>
    <li><b>Communication:</b>
        In-game chats and private chats are private. Public chat lobbies are public.

        Moderators can view private chats for moderation purposes, including but not limited
        to when an accoun has been reported. 
    </li>
</ul>

<h2>Managing your information</h2>
You can close your account by contacting the moderators. If you like to remove
your public content (blog posts, comments) you can message the moderators. We reserve
the right to retain information in backups for moderation and/or legal purposes.

Accounts cannot be deleted because of how OpenGammon works. All your games are linked
to other's games.

<h2>Storage of information</h2>
The collected information is stored on the OpenGammon servers.

<h2>Questions?</h2>
If you have any questions regarding the privacy policy, please use the support 
mail address that can be found on the 
<router-link :to="{name:'support'}">Support page</router-link>.
</div>
</template>

<style scoped>
    h1, :deep(h1){
        @apply text-4xl font-bold mt-6 mb-6
    }
    h2, :deep(h2){
        @apply text-2xl font-semibold my-4
    }
    h3, :deep(h3){
        @apply text-xl font-semibold
    }
    :deep(ol){
        @apply list-decimal list-inside my-4
    }
    :deep(ul){
        @apply list-disc list-inside my-4
    }
    :deep(blockquote){
        @apply px-4 my-4 border-s-4 border-main-3-color bg-main-2-color;
    }
    :deep(p){
        @apply mb-6
    }
    :deep(a){
        @apply underline hover:text-field-color
    }
    table, :deep(table){
        @apply w-full my-4
    }
    tbody tr, :deep(tbody tr){
        @apply hover:bg-main-2-color
    }
    :deep(th){
        @apply py-1 px-6 font-medium 
    }   
    :deep(td){
        @apply py-0.5 px-6 
    }   
    :deep(hr){
        @apply mt-4 mb-6 border-main-2-color
    }   
</style>
